<script setup lang="ts">
import type { IDashboardWidgetProps, TWidgetEmits } from '@tenorlab/vue-dashboard'
import {
  DashboardWidgetBase,
  WrapperColumnContent,
  WrapperColumnContentListItem,
  useWidgetEmits,
} from '@tenorlab/vue-dashboard'

const props = defineProps<IDashboardWidgetProps>()
const emits = defineEmits<TWidgetEmits>()
const emitHandlers = useWidgetEmits(emits)
</script>

<template>
  <DashboardWidgetBase v-bind="props" v-on="emitHandlers">
    <WrapperColumnContent>
      <WrapperColumnContentListItem>
        <div class="text-sm">Next Payment Due:</div>
        <div class="dashboard-number number-base text-primary">Mar 15th, 2025</div>
      </WrapperColumnContentListItem>
      <WrapperColumnContentListItem>
        <div class="text-sm">Last Payment:</div>
        <div class="text-sm flex flex-row gap-2">
          <span class="font-bold text-primary">$4,321</span> on
          <span class="font-bold text-primary">Jan 13th, 2024</span>
        </div>
      </WrapperColumnContentListItem>
    </WrapperColumnContent>
  </DashboardWidgetBase>
</template>
